import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./PrivacyPolicyStyles.css";

function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <main className="privacy-page">
        <h1>Privacy Policy</h1>
        <p className="privacy-effective-date">
          Effective date: February 25, 2026
        </p>

        <section>
          <h2>Information We Collect</h2>
          <p>
            When you request our white paper, we collect your email address.
          </p>
        </section>

        <section>
          <h2>How We Use Information</h2>
          <p>We use submitted email addresses to:</p>
          <ul>
            <li>Measure interest in our publications and insights</li>
            <li>Send occasional related follow-up communications</li>
          </ul>
        </section>

        <section>
          <h2>Third-Party Processing</h2>
          <p>
            We use a third-party form processor to receive form
            submissions on our behalf. By submitting your email, you acknowledge
            that your information is transmitted to and processed by this
            provider.
          </p>
        </section>

        <section>
          <h2>Data Sharing and Retention</h2>
          <p>
            We do not sell personal information collected through this form.
            Submitted email addresses are retained only as long as reasonably
            necessary for the purposes described in this policy or as required
            by law.
          </p>
        </section>

        <section>
          <h2>Your Choices</h2>
          <p>
            You may request access, correction, deletion, or opt out of future
            communications by contacting us at contact@friggacg.com.
          </p>
        </section>

        <section>
          <h2>California Notice</h2>
          <p>
            If you are a California resident, you may have additional privacy
            rights under applicable California law.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will
            be posted on this page with an updated effective date.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
